/* Trustpilot widget reveal — see component-trustpilot.css */
(function () {
  var READY_CLASS = "trustpilot-widget--ready";
  // Long enough for a slow third-party response, short enough that a blocked
  // bootstrap leaves the fallback link on screen rather than nothing.
  var FALLBACK_DELAY = 5000;

  function watch(widget) {
    if (widget.dataset.trustpilotWatched) return;
    widget.dataset.trustpilotWatched = "true";

    var reveal = function () {
      observer.disconnect();
      clearTimeout(timer);
      widget.classList.add(READY_CLASS);
    };
    var check = function () {
      var iframe = widget.querySelector("iframe");
      if (!iframe) return false;
      observer.disconnect();
      clearTimeout(timer);
      // The iframe is blank until it loads, so waiting for that trades the flash
      // of text for nothing rather than for a flash of empty space.
      iframe.addEventListener("load", reveal, { once: true });
      timer = setTimeout(reveal, FALLBACK_DELAY);
      return true;
    };

    var observer = new MutationObserver(check);
    var timer = setTimeout(reveal, FALLBACK_DELAY);
    if (check()) return;
    observer.observe(widget, { childList: true, subtree: true });
  }

  function watchAll(root) {
    if (root.classList && root.classList.contains("trustpilot-widget")) {
      watch(root);
    }
    if (!root.querySelectorAll) return;
    root.querySelectorAll(".trustpilot-widget").forEach(watch);
  }

  watchAll(document);

  // The theme editor swaps in section markup after this has run, and that is the
  // only place a widget appears late — the same case blocks/trustpilot.liquid
  // re-initialises the bootstrap for.
  ["shopify:section:load", "shopify:block:select"].forEach(function (event) {
    document.addEventListener(event, function (e) {
      watchAll(e.target);
    });
  });
})();
